module.exports = __webpack_public_path__ + "img/content.a6e595bf.png";